import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function YoutubeVideoCardAlarm() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="YBY3asWbpcc"
                    title="INSTAR 2K+ Überwachungskameras: Bewegungserkennung optimal einstellen inkl. Objekterkennung und PIR"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="Bewegungserkennung"
              footer={
                <EuiText>
                  <p>INSTAR 2K+ Überwachungskameras: Bewegungserkennung optimal einstellen inkl. Objekterkennung und PIR</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
